/* Catalog and product enhancement; native option links and cart forms remain usable. */
(() => {
  'use strict';
  if (window.__oddCommerceReady) return;
  window.__oddCommerceReady = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const galleries = new WeakSet();
  const requests = new WeakMap();
  const returnFocus = new WeakMap();
  const tones = ['chalk', 'ink', 'sage', 'slate', 'clay'];
  const colors = {chalk: 'Chalk', ink: 'Ink', sage: 'Sage', slate: 'Slate', clay: 'Clay'};

  function show(dialog, trigger) {
    if (!dialog || dialog.open) return;
    returnFocus.set(dialog, trigger || document.activeElement);
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    document.body.classList.add('modal-open');
    init(dialog);
  }
  function close(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close();
    else {dialog.removeAttribute('open'); unlock(dialog);}
  }
  function unlock(dialog) {
    if (!document.querySelector('dialog[open]')) document.body.classList.remove('modal-open');
    const previous = returnFocus.get(dialog);
    if (previous?.isConnected) previous.focus({preventScroll: true});
  }
  function initDialogs(root) {
    root.querySelectorAll('dialog:not([data-oc-dialog-ready])').forEach(dialog => {
      dialog.dataset.ocDialogReady = 'true';
      dialog.addEventListener('close', () => unlock(dialog));
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close(dialog);
      });
    });
  }
  function updateGallery(gallery) {
    const stage = gallery.querySelector('[data-oc-stage]');
    const slides = [...stage.querySelectorAll('.oc-media')];
    if (!stage.clientWidth) return;
    const index = Math.max(0, Math.min(slides.length - 1, Math.round(Math.abs(stage.scrollLeft) / stage.clientWidth)));
    gallery.dataset.index = String(index);
    gallery.querySelectorAll('[data-oc-media]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.ocMedia === slides[index]?.dataset.ocMediaId)));
    const counter = gallery.querySelector('[data-oc-counter]');
    if (counter) counter.textContent = `${index + 1} / ${slides.length}`;
    const enlarge = gallery.querySelector('[data-oc-enlarge]');
    if (enlarge) enlarge.hidden = Boolean(slides[index]?.dataset.ocMediaType && slides[index].dataset.ocMediaType !== 'image');
    slides.forEach((slide, i) => {if (i !== index) slide.querySelectorAll('video').forEach(video => video.pause());});
  }
  function selectMedia(gallery, id, smooth = true) {
    const stage = gallery?.querySelector('[data-oc-stage]');
    if (!stage) return;
    const slides = [...stage.querySelectorAll('.oc-media')];
    let index = typeof id === 'number' ? id : slides.findIndex(slide => slide.dataset.ocMediaId === String(id));
    if (index < 0 || !slides.length) return;
    index = (index + slides.length) % slides.length;
    stage.scrollTo({left: index * stage.clientWidth, behavior: smooth && !reduced.matches ? 'smooth' : 'auto'});
    if (!smooth || reduced.matches) updateGallery(gallery);
  }
  function initGalleries(root) {
    root.querySelectorAll('[data-oc-gallery]').forEach(gallery => {
      if (galleries.has(gallery)) return;
      galleries.add(gallery);
      const stage = gallery.querySelector('[data-oc-stage]');
      let scheduled = false;
      stage.addEventListener('scroll', () => {
        if (scheduled) return;
        scheduled = true; requestAnimationFrame(() => {updateGallery(gallery); scheduled = false;});
      }, {passive: true});
      stage.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();selectMedia(gallery, Number(gallery.dataset.index || 0) + (event.key === 'ArrowRight' ? 1 : -1));
      });
      updateGallery(gallery);
      const product = gallery.closest('[data-oc-product]');
      if (product?.dataset.featuredMedia) requestAnimationFrame(() => selectMedia(gallery, product.dataset.featuredMedia, false));
    });
  }
  function setTone(root, tone) {
    if (!tones.includes(tone)) tone = 'chalk';
    root.classList.remove(...tones.map(value => `tone-${value}`));
    root.classList.add(`tone-${tone}`);
    root.dataset.tone = tone;
    root.querySelector('[data-oc-color-label]').textContent = colors[tone];
    root.querySelectorAll('[data-oc-tone]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.ocTone === tone)));
  }
  function openSample(button) {
    const dialog = document.getElementById('SampleDialog');
    if (!dialog) return;
    const root = dialog.querySelector('[data-oc-demo-product]');
    const hoodie = button.dataset.kind === 'hoodie';
    dialog.querySelector('#SampleHeading').textContent = button.dataset.title || (hoodie ? 'Sweatshirt' : 'T-shirt');
    dialog.querySelectorAll('[data-sample-tee]').forEach(art => art.hidden = hoodie);
    dialog.querySelectorAll('[data-sample-hoodie]').forEach(art => art.hidden = !hoodie);
    setTone(root, button.dataset.tone || tones.find(tone => button.classList.contains(`tone-${tone}`)) || 'chalk');
    root.querySelectorAll('[data-oc-size]').forEach(size => size.setAttribute('aria-pressed', 'false'));
    root.querySelector('[data-oc-size-label]').textContent = 'Select';
    show(dialog, button);dialog.scrollTop = 0;
    requestAnimationFrame(() => selectMedia(root.querySelector('[data-oc-gallery]'), 0, false));
  }
  function zoom(gallery, trigger, directLink) {
    const dialog = document.getElementById('OcImageZoom');
    if (!dialog || !gallery) return;
    const holder = dialog.querySelector('[data-oc-zoom-content]');
    const slide = gallery.querySelectorAll('.oc-media')[Number(gallery.dataset.index || 0)];
    const img = directLink?.querySelector('img') || slide?.querySelector('img');
    holder.replaceChildren();holder.classList.remove('is-magnified');holder.removeAttribute('style');
    if (img) {
      const copy = new Image();copy.src = directLink?.href || slide.querySelector('[data-oc-zoom]')?.href || img.currentSrc || img.src;
      copy.alt = img.alt || 'Product detail';holder.append(copy);
    } else {
      const art = slide?.querySelector('div:not([hidden]) .sample-garment');
      if (!art) return;
      const copy = art.cloneNode(true);
      copy.querySelectorAll('[id]').forEach(node => {
        const previous = node.id;const next = `${previous}-zoom`;
        copy.querySelectorAll('[fill],[stroke]').forEach(child => {
          ['fill','stroke'].forEach(attr => {if (child.getAttribute(attr) === `url(#${previous})`) child.setAttribute(attr, `url(#${next})`);});
        });node.id = next;
      });
      const style = getComputedStyle(art);
      ['--cloth','--cloth-hi','--cloth-lo'].forEach(name => holder.style.setProperty(name, style.getPropertyValue(name)));
      holder.append(copy);
    }
    show(dialog, trigger);dialog.scrollTop = 0;dialog.scrollLeft = 0;
  }
  function syncPlan(root) {
    const select = root.querySelector('[data-oc-plan]');
    const price = root.querySelector('[data-oc-price]');
    if (!select || !price) return;
    const option = select.selectedOptions[0];
    price.textContent = option?.dataset.price || price.dataset.basePrice;
    const compare = root.querySelector('[data-oc-compare]');if(compare) compare.hidden = Boolean(option?.value);
    if (select.required && !option) {const add=root.querySelector('[data-oc-add]');if(add){add.disabled=true;add.textContent='Unavailable';}}
  }
  async function selectOption(link, event) {
    const root = link.closest('[data-oc-product]');
    if (!root || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button) return;
    const url = new URL(link.href, location.href);
    const productUrl = new URL(root.dataset.ocUrl, location.href);
    if (url.origin !== location.origin || url.pathname !== productUrl.pathname) return;
    event.preventDefault();
    const ids = root.dataset.selectedOptions.split(',');
    ids[Number(link.dataset.ocPosition) - 1] = link.dataset.ocOption;
    root.dataset.selectedOptions = ids.join(',');
    url.searchParams.delete('variant');url.searchParams.set('option_values', ids.join(','));
    const previewId = new URL(location.href).searchParams.get('preview_theme_id');
    if(previewId) url.searchParams.set('preview_theme_id',previewId);
    const requestUrl = new URL(url);requestUrl.searchParams.set('section_id',root.dataset.ocSection);
    requests.get(root)?.abort();const controller = new AbortController();requests.set(root,controller);
    const info = root.querySelector('[data-oc-info]');
    const oldQuantity = Number(info.querySelector('[name=quantity]')?.value || 1);
    info.setAttribute('aria-busy','true');
    const add=info.querySelector('[data-oc-add]');if(add)add.disabled=true;
    info.querySelector('[data-oc-status]').textContent='Updating...';
    link.closest('fieldset').querySelectorAll('[data-oc-option]').forEach(item => {
      const active = item === link;item.classList.toggle('is-selected',active);
      if(active)item.setAttribute('aria-current','true');else item.removeAttribute('aria-current');
    });
    try {
      const response = await fetch(requestUrl, {signal:controller.signal, credentials:'same-origin', headers:{Accept:'text/html'}});
      if(!response.ok)throw new Error(`Product request failed: ${response.status}`);
      const doc = new DOMParser().parseFromString(await response.text(),'text/html');
      if(requests.get(root)!==controller)return;
      const replacement=doc.querySelector('[data-oc-product]');
      const nextInfo=replacement?.querySelector('[data-oc-info]');
      if(!nextInfo || replacement.dataset.ocSection!==root.dataset.ocSection)throw new Error('Product section missing');
      const oldApps=info.querySelector('[data-oc-apps]');const nextApps=nextInfo.querySelector('[data-oc-apps]');
      if(oldApps && nextApps)nextApps.replaceWith(oldApps);
      info.replaceWith(nextInfo);
      root.dataset.selectedOptions=replacement.dataset.selectedOptions;
      root.dataset.featuredMedia=replacement.dataset.featuredMedia || '';
      const quantity=nextInfo.querySelector('[name=quantity]');
      if(quantity){const min=Number(quantity.min||1),step=Number(quantity.step||1),max=quantity.max?Number(quantity.max):Infinity;const candidate=min+Math.max(0,Math.floor((oldQuantity-min)/step))*step;quantity.value=String(Math.min(candidate,max));}
      const variant=nextInfo.querySelector('[name=id]')?.value;
      if(variant){url.searchParams.delete('option_values');url.searchParams.set('variant',variant);}
      history.replaceState(history.state,'',url);
      init(nextInfo);syncPlan(nextInfo);
      if(root.dataset.featuredMedia)selectMedia(root.querySelector('[data-oc-gallery]'),root.dataset.featuredMedia,false);
      const selected=[...nextInfo.querySelectorAll('[data-oc-option]')].find(item=>item.dataset.ocOption===link.dataset.ocOption);
      selected?.focus({preventScroll:true});
      root.dispatchEvent(new CustomEvent('oddhabit:variant-change',{bubbles:true,detail:{variantId:variant||null}}));
    } catch(error) {
      if(error.name==='AbortError')return;
      const status=info.querySelector('[data-oc-status]');
      status.textContent='Unable to update. ';
      const retry=document.createElement('a');retry.href=url.href;retry.textContent='Open selected option';retry.style.textDecoration='underline';status.append(retry);
    } finally {
      if(requests.get(root)===controller){root.querySelector('[data-oc-info]')?.removeAttribute('aria-busy');requests.delete(root);}
    }
  }
  // Capture prevents the older, simpler sample popup handler from opening as well.
  document.addEventListener('click',event=>{
    const sample=event.target instanceof Element ? event.target.closest('[data-sample-open]') : null;
    if(sample && document.querySelector('#SampleDialog.oc-sample-dialog')){event.preventDefault();event.stopPropagation();openSample(sample);}
  },true);
  document.addEventListener('click',event=>{
    const target=event.target instanceof Element ? event.target : null;if(!target)return;
    const option=target.closest('[data-oc-option]');if(option){selectOption(option,event);return;}
    const closer=target.closest('[data-oc-close]');if(closer){close(closer.closest('dialog'));return;}
    const opener=target.closest('[data-oc-dialog]');if(opener){show(document.getElementById(opener.dataset.ocDialog),opener);return;}
    const category=target.closest('[data-oc-category]');if(category){
      const root=category.closest('[data-oc-catalog]');let count=0;
      root.querySelectorAll('[data-sample-category]').forEach(card=>{card.hidden=category.dataset.ocCategory!=='all' && category.dataset.ocCategory!==card.dataset.sampleCategory;if(!card.hidden)count++;});
      root.querySelectorAll('[data-oc-category]').forEach(button=>button.setAttribute('aria-pressed',String(button===category)));
      root.querySelector('[data-oc-count]').textContent=`${count} samples`;return;
    }
    const density=target.closest('[data-oc-density]');if(density){const root=density.closest('[data-oc-catalog]');root.dataset.density=density.dataset.ocDensity;root.querySelectorAll('[data-oc-density]').forEach(button=>button.setAttribute('aria-pressed',String(button===density)));return;}
    const filter=target.closest('[data-oc-filter-toggle]');if(filter){const panel=document.getElementById(filter.getAttribute('aria-controls'));const open=panel.classList.toggle('is-open');filter.setAttribute('aria-expanded',String(open));return;}
    const tone=target.closest('[data-oc-tone]');if(tone){setTone(tone.closest('[data-oc-demo-product]'),tone.dataset.ocTone);return;}
    const size=target.closest('[data-oc-size]');if(size){const root=size.closest('[data-oc-demo-product]');root.querySelectorAll('[data-oc-size]').forEach(button=>button.setAttribute('aria-pressed',String(button===size)));root.querySelector('[data-oc-size-label]').textContent=size.dataset.ocSize;return;}
    const thumb=target.closest('[data-oc-media]');if(thumb){selectMedia(thumb.closest('[data-oc-gallery]'),thumb.dataset.ocMedia);return;}
    const galleryStep=target.closest('[data-oc-previous],[data-oc-next]');if(galleryStep){const gallery=galleryStep.closest('[data-oc-gallery]');selectMedia(gallery,Number(gallery.dataset.index||0)+(galleryStep.hasAttribute('data-oc-next')?1:-1));return;}
    const enlarge=target.closest('[data-oc-enlarge],[data-oc-zoom]');if(enlarge){event.preventDefault();zoom(enlarge.closest('[data-oc-gallery]'),enlarge,enlarge.matches('a')?enlarge:null);return;}
    const zoomContent=target.closest('[data-oc-zoom-content]');if(zoomContent){zoomContent.classList.toggle('is-magnified');return;}
    const quantity=target.closest('[data-oc-step]');if(quantity){const input=quantity.parentElement.querySelector('input');try{quantity.dataset.ocStep==='up'?input.stepUp():input.stepDown();input.dispatchEvent(new Event('change',{bubbles:true}));}catch(error){input.reportValidity();}}
  });
  document.addEventListener('change',event=>{
    const target=event.target;if(!(target instanceof Element))return;
    if(target.matches('[data-oc-sort]'))target.form?.requestSubmit();
    if(target.matches('[data-oc-plan]'))syncPlan(target.closest('[data-oc-info]'));
  });
  function init(root=document){initDialogs(root);initGalleries(root);root.querySelectorAll('[data-oc-plan]').forEach(select=>syncPlan(select.closest('[data-oc-info]')));}
  init();document.addEventListener('shopify:section:load',event=>init(event.target));
  window.addEventListener('resize',()=>document.querySelectorAll('[data-oc-gallery]').forEach(gallery=>updateGallery(gallery)),{passive:true});
})();
